/*
  **Zuletzt geöffnet** (#233, CONTEXT.md): Aufgaben und Projekte, die man zuletzt angesehen hat —
  die **Suche** zeigt sie vor dem Tippen. Eine Aufgabe zählt, sobald ihre Details aufgehen oder sie
  aufgeklappt in der Liste steht (`TaskEntry`, seit 02.10.2026); ein Projekt, sobald sein Tab vorn steht. Nur auf diesem Gerät, in `localStorage`: eine
  Bequemlichkeit, keine Daten; ein Sync wäre Aufwand ohne Nutzen (entschieden 01.10.2026).
  Gelöschtes bleibt hier stehen und fällt beim Lesen in der Suche heraus.
*/

export type RecentKind = 'task' | 'project'

export interface RecentItem {
  kind: RecentKind
  id: string
}

export const RECENT_LIMIT = 20
export const RECENT_STORAGE_KEY = 'happytask:recent-items'

/** Die Einträge, der jüngste zuerst. Kaputter oder gesperrter Speicher heißt: noch nichts geöffnet. */
export function readRecent(): RecentItem[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(RECENT_STORAGE_KEY) ?? '[]')
    if (!Array.isArray(parsed)) return []
    return parsed.filter((item): item is RecentItem =>
      item != null && (item.kind === 'task' || item.kind === 'project') && typeof item.id === 'string')
  } catch {
    return []
  }
}

/**
 * Setzt den Eintrag nach vorn; ein schon vorhandener wandert mit. Je Art bleiben höchstens 20 —
 * getrennt, denn wer bei offenen Details durch die Liste blättert, zeichnet jede Aufgabe auf und
 * verdrängte sonst alle Projekte (Diff-Audit 02.10.2026).
 */
export function recordRecent(item: RecentItem): void {
  const rest = readRecent().filter(entry => entry.kind !== item.kind || entry.id !== item.id)
  const next = [{ kind: item.kind, id: item.id }, ...rest]
  const kept = (['task', 'project'] as const).flatMap(kind => next.filter(entry => entry.kind === kind).slice(0, RECENT_LIMIT))
  try {
    localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(next.filter(entry => kept.includes(entry))))
  } catch {
    // Voller oder gesperrter Speicher: Die Liste ist eine Bequemlichkeit, die Seite geht vor.
  }
}
